import { useContext, useEffect, useState } from "react";
import { Produto, SelectOptions } from "../../@types";
import BotaoFiltrar from "../../components/botaofiltrar";
import FiltroInput from "../../components/filtroinput";
import { Container, DateInput, DropDown, HeaderRotulo, HeaderValor, LinhaFiltros, LinhaSkeleton, MensagemContainer, QuadroHeader, Tabela } from "./styles";
import APIQuadroVagas from "../../services/APIQuadroVagas";
import APIPonto from "../../services/APIPonto";
import { CustumerContext } from "../../contexts/custumer";
import { ILocal } from "../../@interfaces";
import Options from "../../components/select/options";
import ToastContext from "../../contexts/toast";

import Skeleton from "react-loading-skeleton";
import { useQuadroDeVagas } from "./useQuadroDeVagas";
import aux from "../../utils/auxiliar";
import MensagemListaVazia from "../../components/mensagemlistavazia";
import moment from "moment";
import Loading from "../../components/loading";
import Button from "../../components/button";
import Subtitle from "../../components/subtitle";
import Text from "../../components/text";
import Title from "../../components/title";
import useIsMobile from "../../hooks/useIsMobile";
import CardVagaMobile from "./components";
import { IoChevronDown } from "react-icons/io5";
import Input from "../../components/input";


const QuadrodeVagas: React.FC = () => {
  const {
    quadro,
    quadroFiltrado,
    searchValue,
    filterBySearch,
    locais,
    filtros,
    opcaoDeFiltroAberta,
    carregandoQuadro,
    carregandoLocais,
    carregarQuadro,
    abrirDropdown,
    fecharDropdown,
    selecionarFiltro,
    opcoesOrdem,
    dataInvalida
  } = useQuadroDeVagas();


  function Placeholder() {
    return (
      <>
        <Skeleton height={40} width={'100%'} style={{ marginBottom: 30 }} />

        {Array(4).fill(0).map((item, index) => (
          <LinhaSkeleton key={index}>
            {Array(7).fill(0).map((item, index) => <Skeleton height={20} key={index} />)}
          </LinhaSkeleton>
        ))}
      </>
    )
  }

  const COLS_SPAN_MAIOR = 3;
  const COLS_SPAN_MEDIO = 2;
  const COLS_SPAN_PEQUENO = 1.5;


  const semDadosParaExibir = !quadroFiltrado || quadroFiltrado.length === 0 || (quadroFiltrado.length === 1 && quadroFiltrado[0].produtos.length === 0);
  const isMobile = useIsMobile();

  return (
    <Container>


      {!!opcaoDeFiltroAberta &&
        <Options
          itens={opcaoDeFiltroAberta === 'local' ? locais : opcoesOrdem}
          close={fecharDropdown}
          selectOption={(valor) => selecionarFiltro(opcaoDeFiltroAberta, valor)}
          sortAlphabetically
        />
      }

      {carregandoLocais && <Loading />}

      {!carregandoLocais && <LinhaFiltros>

        <div className={`w-fit flex gap-4 ${isMobile && 'flex-col'} max-[580px]:w-full`}>
          <div className="gap-2 flex items-center max-[1370px]:flex-col max-[1370px]:items-start max-[1370px]:gap-1">
            <Subtitle className='!text-[.875rem] !leading-3'>
              Período <Text className="!text-[.625rem] !text-[rgba(0,0,0,.5)]" >(máx. 30 dias)</Text>
            </Subtitle>
            <div className="flex gap-2 items-center max-[580px]:w-full">
              <div className="relative max-[580px]:w-full">
                <DateInput
                  type={'date'}
                  onChange={e => selecionarFiltro('dataInicio', e.target.value)}
                  value={filtros.dataInicio}
                  max={"9999-12-31"}
                  data-testid="data_inicial"
                  className={`max-[580px]:!w-full`}
                  invalid={dataInvalida}
                />
                {isMobile && <IoChevronDown size={12} className="text-[rgba(0,0,0,0.5)] absolute right-[14px] top-[50%] translate-y-[-50%] pointer-events-none" />}
              </div>
              -
              <div className="relative max-[580px]:w-full">
                <DateInput
                  type={'date'}
                  onChange={e => selecionarFiltro('dataFinal', e.target.value)}
                  value={filtros.dataFinal}
                  max={"9999-12-31"}
                  data-testid="data_final"
                  className={`max-[580px]:!w-full`}
                  invalid={dataInvalida}
                />
                {isMobile && <IoChevronDown size={12} className="text-[rgba(0,0,0,0.5)] absolute right-[14px] top-[50%] translate-y-[-50%] pointer-events-none" />}
              </div>
            </div>
          </div>

          <div className="flex gap-4 max-[465px]:flex-col">
            <div className={`gap-2 flex items-center max-[1370px]:flex-col max-[1370px]:items-start max-[1370px]:gap-1.75 ${isMobile && 'w-full'}`}>
              <Subtitle className='!text-[.875rem]'>
                Ordem
              </Subtitle>

              <DropDown className={`!h-[32.800px] ${isMobile && '!w-full'}`} onClick={() => abrirDropdown("ordem")}>
                <Text className="!overflow-ellipsis !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{opcoesOrdem.find(item => item.value === filtros?.ordem)?.label}</Text>
                <IoChevronDown size={12} />
              </DropDown>

            </div>

            <div className={`gap-2 flex items-center max-[1370px]:flex-col max-[1370px]:items-start max-[1370px]:gap-1.75 ${isMobile && 'w-full'}`}>
              <Subtitle className='!text-[.875rem]'>
                Local
              </Subtitle>

              <DropDown className={`!h-[32.800px] ${isMobile && '!w-full'}`} onClick={() => abrirDropdown("local")}>
                <Text className="!overflow-ellipsis !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{locais?.find(item => item.value === filtros.local)?.label}</Text>
                <IoChevronDown size={12} />
              </DropDown>

            </div>
          </div>
        </div>
        {filtros.dataInicio && filtros.dataFinal && <BotaoFiltrar className="!self-end !block max-[1200px]:!hidden" onClick={carregarQuadro} loading={carregandoQuadro} />}

        <div className='w-full flex items-center max-[1200px]:justify-between justify-end gap-[50px]'>
          {filtros.dataInicio && filtros.dataFinal && <BotaoFiltrar className='!hidden !h-[31.6px] max-[1200px]:!block' onClick={carregarQuadro} loading={carregandoQuadro} />}
          {quadro && quadro.length > 0 && (
            <Input
              placeholder="Pesquisar..."
              isSearch colorOfBorder={"#cecece"}
              value={searchValue}
              onChange={(e) => filterBySearch(e.target.value)}
              containerStyle={{ maxWidth: '265px' }}
            />
          )}
        </div>
      </LinhaFiltros>}

      {carregandoQuadro && <Placeholder />}

      {!carregandoQuadro && quadroFiltrado?.map((local, index) => (

        <div key={local.iDLocal}>
          {quadroFiltrado?.length > 1 && <h1 style={{ margin: '30px 0 20px' }}>{local.nomeLocal}</h1>}

          {local.produtos.map((produto, produtoIndex) => (
            <div key={`${produto.produto}-${produtoIndex}`} style={{ position: 'relative' }}>
              <QuadroHeader>
                {/* Desktop */}
                <div className="hidden min-[800px]:flex items-center gap-[7px]">
                  <Title className="!text-[#2991D6]">Produto:</Title>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">{produto.produto}</Text>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
                  <Title className="!text-[#2991D6]">Escala:</Title>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">{produto.escala}</Text>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
                  <Title className="!text-[#2991D6]">Cargo:</Title>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">{produto.cargo}</Text>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
                  <Title className="!text-[#2991D6]">Turno:</Title>
                  <Text className="text-[1rem] !text-[rgba(0,0,0,.5)]">{produto.turno}</Text>
                </div>

                {/* Mobile */}
                <div className="flex min-[800px]:hidden flex-col w-full justify-center">
                  <div className="flex items-center justify-start w-full">
                    <div className="flex-1 flex justify-start items-center gap-[7px]">
                      <Title className="!text-[#2991D6] max-[560px]:text-[.875rem]">Produto:</Title>
                      <Text className="text-[1rem] max-[560px]:text-[.875rem] !text-[rgba(0,0,0,.5)]">{produto.produto}</Text>
                    </div>
                  </div>
                  <div className="flex items-center justify-start w-full">
                    <div className="flex-1 flex justify-start items-center gap-[7px]">
                      <Title className="!text-[#2991D6] max-[560px]:text-[.875rem]">Cargo:</Title>
                      <Text className="text-[1rem] max-[560px]:text-[.875rem] !text-[rgba(0,0,0,.5)]">{produto.cargo}</Text>
                    </div>
                  </div>

                  <div className="flex items-center justify-between w-full">
                    <div className="flex-1 flex justify-start items-center pr-2 gap-[7px]">
                      <Title className="!text-[#2991D6] max-[560px]:text-[.875rem]">Escala:</Title>
                      <Text className="text-[1rem] max-[560px]:text-[.875rem] !text-[rgba(0,0,0,.5)]">{produto.escala}</Text>
                    </div>
                    <div className="flex-1 flex justify-end items-center pl-2 gap-[7px]">
                      <Title className="!text-[#2991D6] max-[560px]:text-[.875rem]">Turno:</Title>
                      <Text className="text-[1rem] max-[560px]:text-[.875rem] !text-[rgba(0,0,0,.5)]">{produto.turno}</Text>
                    </div>
                  </div>
                </div>
              </QuadroHeader>

              {produto.vagas?.length! > 0 && (
                isMobile ? (

                  <div className="flex flex-col gap-2 p-3">
                    {produto.vagas?.map(item => (
                      <CardVagaMobile key={`${item.vaga}-${item.data}`} data={item} />
                    ))}
                  </div>
                ) : (
                  <Tabela>
                    <thead>
                      <tr className="text-gray-700">
                        <th>Vaga</th>
                        <th>Data</th>
                        <th>Situação</th>
                        <th colSpan={COLS_SPAN_PEQUENO}>Tipo</th>
                        <th colSpan={COLS_SPAN_MAIOR}>Efetivo</th>
                        <th colSpan={COLS_SPAN_MEDIO}>Horário Vaga</th>
                        <th colSpan={COLS_SPAN_PEQUENO}>Situação</th>
                        <th colSpan={COLS_SPAN_MAIOR}>Cobertura</th>
                        <th colSpan={COLS_SPAN_MEDIO}>Horário Ponto</th>
                      </tr>
                    </thead>

                    <tbody>
                      {produto.vagas?.map(item => (
                        <tr className="odd:bg-white hover:bg-[#EEEEEE]" key={`${item.vaga}-${item.data}`}>
                          <td>{item.vaga}</td>
                          <td>{moment(item.data).utc().format('DD/MM/YYYY')}</td>
                          <td>{item.situacao}</td>
                          <td colSpan={COLS_SPAN_PEQUENO}>{item.origemVaga}</td>
                          <td colSpan={COLS_SPAN_MAIOR}>
                            {item.efetivo ? `${item.efetivo.re} - ${item.efetivo.nome}` : '-'}
                          </td>
                          <td colSpan={COLS_SPAN_MEDIO}>
                            {item.horarioVaga
                              ? `${item.horarioVaga.entrada} ${item.horarioVaga.saidaRefeicao} ${item.horarioVaga.retornoRefeicao} ${item.horarioVaga.saida}`
                              : '-'}
                          </td>
                          <td colSpan={COLS_SPAN_PEQUENO}>{item.situacaoCobertura}</td>
                          <td colSpan={COLS_SPAN_MAIOR}>
                            {item.cobertura ? `${item.cobertura.re} - ${item.cobertura.nome}` : '-'}
                          </td>
                          <td colSpan={COLS_SPAN_MEDIO}>
                            {item.horarioPonto
                              ? `${item.horarioPonto.entrada} ${item.horarioPonto.saidaRefeicao} ${item.horarioPonto.retornoRefeicao} ${item.horarioPonto.saida}`
                              : '-'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Tabela>
                )
              )}
              {produto.vagas?.length === 0 && <MensagemContainer> <Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]"> Não há vagas a serem exibidas</Text></MensagemContainer>}

            </div>
          ))}

        </div>
      ))}


      {semDadosParaExibir && !carregandoQuadro && !carregandoLocais && <MensagemListaVazia texto="Não há vagas a serem exibidas" textoSecundario={"Filtre para buscar vagas"} />}
    </Container>
  )
}


export default QuadrodeVagas;